import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "./Desk.scss";
import principalImage from "../../assets/images/principal.jpg"; // Replace with actual image path.
import Header from "../../components/ActivePath/Header";

import kumarImg from '../../assets/images/profile/KUMAR PRINCIPAL.jpg';
import shashidharYRImg from '../../assets/images/profile/SHASHIDAR.jpg';
import rajeshKImg from '../../assets/images/profile/RAJESH.jpg';
import rajuKImg from '../../assets/images/profile/RAJU.jpg';
import shilpaLImg from '../../assets/images/profile/SHILPA.jpg';
import yashaswiniSDImg from '../../assets/images/profile/YASASHVINI.jpg';
import kuberachariImg from '../../assets/images/profile/KUBERACHARI.jpg';
import gangadharappaImg from '../../assets/images/profile/GANGADHAR.jpg';
import padmaSahuImg from '../../assets/images/profile/PADMA.jpg';

import premaImg from '../../assets/images/profile/avatar5.png';
import arunakumariImg from '../../assets/images/profile/avatar5.png';
import krishnamurthyImg from '../../assets/images/profile/img_avatar.png';
import sheelaImg from '../../assets/images/profile/avatar5.png';
import bhavyaImg from '../../assets/images/profile/avatar5.png';
import shashidharBCImg from '../../assets/images/profile/img_avatar.png';
import kavithaImg from '../../assets/images/profile/avatar5.png';


const PrincipalDesk: React.FC = () => {
  useEffect(() => {
    AOS.init({ duration: 1000, easing: "ease-in-out" });
  }, []);

  const staffList = [
    {
      name: 'Mr. Kumar R',
      designation: 'Principal (E&C)',
      qualification: 'BE (E&C)',
      experience: '30 Years',
      image: kumarImg,
    },
    {
      name: 'Mr. Shashidhar Y R',
      designation: 'Lecturer (E&C)',
      qualification: 'BE (E&C)',
      experience: '27 Years',
      image: shashidharYRImg,
    },
    {
      name: 'Mr. Rajesh K',
      designation: 'Lecturer (E&C)',
      qualification: 'BE (E&C)',
      experience: '18 Years',
      image: rajeshKImg,
    },
    {
      name: 'Mr. Raju K',
      designation: 'Lecturer (Science)',
      qualification: 'MSc (Science)',
      experience: '30 Years',
      image: rajuKImg,
    },
    {
      name: 'Ms. Shilpa L',
      designation: 'Lecturer (E&C)',
      qualification: 'BE (E&C)',
      experience: '18 Years',
      image: shilpaLImg,
    },
    {
      name: 'Ms. Yashaswini S D',
      designation: 'Lecturer (E&C)',
      qualification: 'BE (E&C)',
      experience: '16 Years',
      image: yashaswiniSDImg,
    },
    {
      name: 'Mr. Kuberachari S H',
      designation: 'Lecturer (E&C)',
      qualification: 'BE, M-Tech (E&C)',
      experience: '15 Years',
      image: kuberachariImg,
    },
    {
      name: 'Mr. Gangadharappa B G',
      designation: 'Instructor (E&C)',
      qualification: 'Dip/Post Diploma',
      experience: '29 Years',
      image: gangadharappaImg,
    },
    {
      name: 'Ms. Padma Sahu',
      designation: 'Asst. Instructor (E&C)',
      qualification: 'Dip/Post Diploma',
      experience: '24 Years',
      image: padmaSahuImg,
    },
  ];
  
  const supportingStaff = [
    {
      name: 'Ms. Prema K S',
      designation: 'Helper (Science)',
      qualification: '',
      experience: '',
      image: premaImg,
    },
    {
      name: 'Ms. Arunakumari K R',
      designation: 'Helper (E&C)',
      qualification: '',
      experience: '',
      image: arunakumariImg,
    },
    {
      name: 'Mr. Krishnamurthy D H',
      designation: 'Helper (E&C)',
      qualification: '',
      experience: '',
      image: krishnamurthyImg,
    },
    {
      name: 'Ms. Sheela H G',
      designation: 'FDA',
      qualification: '',
      experience: '',
      image: sheelaImg,
    },
    {
      name: 'Ms. Bhavya M M',
      designation: 'SDA',
      qualification: '',
      experience: '',
      image: bhavyaImg,
    },
    {
      name: 'Mr. Shashidhar B C',
      designation: 'Group-D',
      qualification: '',
      experience: '',
      image: shashidharBCImg,
    },
    {
      name: 'Ms. Kavitha H O',
      designation: 'Group-D',
      qualification: '',
      experience: '',
      image: kavithaImg,
    },
  ];
  

  return (
    <section className="principal-desk">
        <Header pageTitle="" breadcrumb="Desk" />
      <div className="header" data-aos="fade-down">
        <h1>Principal's Desk</h1>
        <p>Welcome to SJM Polytechnic, Birur</p>
      </div>
      <div className="content">
        <div className="image-container" data-aos="fade-right">
          <img src={principalImage} alt="Principal" />
        </div>
        <div className="message" data-aos="fade-left">
          <h2>Mr. Kumar R</h2>
          <h3>Principal</h3>
          <p>
            Dear All, <br />
            Greetings from The SJM Polytechnic, Birur!
          </p>
          <p>
            On behalf of the Management of SJMP, and the faculty and staff of
            the college, I welcome you on-board. The college is just behind the
            Shree Veerabhadreshwara temple by a beautiful landscape that will
            make your stay blessed and comfortable.
          </p>
          <p>
            Technical Education is the backbone of every nation and is the
            stepping stone for a country to move into the niche of a developed
            nation. SJM Mahasamsthan has been contributing in the mission of
            transforming rural India into a developed nation by running SJM
            Polytechnic at Birur with innovation, creativity, human
            intelligence, and patience. “Service to Human being is Service to
            God.”
          </p>
          <p>
            It gives me immense pleasure to welcome you to the creative hub of
            SJMP, which has a very friendly campus and is equipped with
            state-of-the-art infrastructure. We have well-equipped labs,
            workshops, and libraries to help students attain the highest
            standards in academics and professional skills.
          </p>
          <p>
            SJM Polytechnic was started in the year 1984 with a vision to meet
            the needs of a futuristic society through technology. The institute
            has grown over the years in pursuit of this vision and crossed
            several milestones of excellence.
          </p>
          <p>
            This has become possible only due to the continued patronage of the
            management, tireless efforts of its experienced, qualified faculty
            and staff members, and worthy contributions of its dedicated
            students and alumni.
          </p>
          <p>Best wishes,</p>
          <p>Principal</p>
        </div>
      </div>
      {/* Staff Desk Section */}
<div className="staff-desk" data-aos="fade-up">
  <h2>Our Esteemed Staff</h2>
  <div className="staff-grid">
  {staffList.map((staff, index) => (
    <div className="staff-card" key={index}>
      <img src={staff.image} alt={staff.name} />
      <div className="info">
        <h3>{staff.name}</h3>
        <p><strong>Designation:</strong> {staff.designation}</p>
        <p><strong>Qualification:</strong> {staff.qualification}</p>
        <p><strong>Experience:</strong> {staff.experience}</p>
      </div>
    </div>
  ))}
</div>

{/* Supporting Staff Section */}
<div className="staff-desk" data-aos="fade-up">
  <h2>Supporting Staff</h2>
  <div className="staff-grid">
    {supportingStaff.map((staff, index) => (
      <div className="staff-card" key={index}>
        <img src={staff.image} alt={staff.name} />
        <div className="info">
          <h3>{staff.name}</h3>
          <p><strong>Designation:</strong> {staff.designation}</p>
          {staff.qualification && <p><strong>Qualification:</strong> {staff.qualification}</p>}
          {staff.experience && <p><strong>Experience:</strong> {staff.experience}</p>}
        </div>
      </div>
    ))}
  </div>
</div>


</div>

    </section>
  );
};

export default PrincipalDesk;
